// DailyTransactionsChart.js
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Chart from 'react-apexcharts'

function DailyTransactionsChart({ userId }) {
  const [chartData, setChartData] = useState({
    categories: [],
    series: [],
  })

  useEffect(() => {
    fetchDailyTransactions(userId)
  }, [userId])

  const fetchDailyTransactions = async (uid) => {
    try {
      // e.g. GET /api/stats/daily-last30/:userId
      const res = await axios.get(`https://payme-backend-713827320947.asia-northeast1.run.app/api/stats/daily-last30/${uid}`)
      // Suppose res.data => [{ date: '2025-02-01', total: 1200 }, { date: '2025-02-02', total: 600 }, ... ]
      const data = res.data

      // Sort by date if needed
      data.sort((a, b) => a.date.localeCompare(b.date))

      // categories => date
      const categories = data.map((d) => d.date)
      // series => total
      const series = data.map((d) => d.total)

      setChartData({
        categories,
        series,
      })
    } catch (err) {
      console.error('Error fetching last-30-days data:', err)
    }
  }

  const options = {
    chart: {
      id: 'daily-last30-line',
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    xaxis: {
      categories: chartData.categories, // e.g. "2025-02-07"
      title: { text: 'Date' },
    },
    yaxis: {
      title: { text: 'Amount (¥)' },
    },
    stroke: { curve: 'smooth' },
    dataLabels: { enabled: false },
    colors: ['#556ee6'],
    legend: { position: 'bottom' },
    grid: { borderColor: '#f1f1f1' },
  }

  const series = [
    {
      name: 'Transactions',
      data: chartData.series,
    },
  ]

  return (
    <div className="bg-white p-4 rounded shadow">
      <h3 className="text-base font-semibold text-gray-700 mb-2">
        Transactions (Last 30 Days)
      </h3>
      <Chart options={options} series={series} type="line" height={280} />
    </div>
  )
}

export default DailyTransactionsChart
